import eControllerTypes from './eControllerTypes';

export default {
  EPCT_DROPDOWN: `${eControllerTypes.ERCCT_MAIN_POPUP}__dropdown`,
}
